import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export function usePlans() {
  const [plans, setPlans] = useState(cache);
  useEffect(() => {
    api.get("/plans").then((r) => { cache = r.data; setPlans(r.data); }).catch(() => setPlans((p) => p || []));
  }, []);
  return plans;
}

export const euros = (n) => `${Number.isInteger(n) ? n : n.toFixed(2).replace(".", ",")}€`;
